import React, { Fragment, useState, useEffect } from "react";
import tools from "../../components/tools/tools";
import Select from '../../components/select'
import PhoneInput from "../../components/react-input-number";

// Datos de tipos de ocupación (números sin decimal)
const TIPOS_OCUPACION = [
    { clave: "01", label: "01 - Cultivo, crianza y aprovechamiento", value: "01 - Cultivo, crianza y aprovechamiento" },
    { clave: "02", label: "02 - Extracción y suministro", value: "02 - Extracción y suministro" },
    { clave: "03", label: "03 - Construcción", value: "03 - Construcción" },
    { clave: "04", label: "04 - Tecnología", value: "04 - Tecnología" },
    { clave: "05", label: "05 - Procesos industriales", value: "05 - Procesos industriales" },
    { clave: "06", label: "06 - Transporte", value: "06 - Transporte" },
    { clave: "07", label: "07 - Provisión de bienes y servicios", value: "07 - Provisión de bienes y servicios" },
    { clave: "08", label: "08 - Gestión y soporte administrativo", value: "08 - Gestión y soporte administrativo" },
    { clave: "09", label: "09 - Salud y protección social", value: "09 - Salud y protección social" },
    { clave: "10", label: "10 - Comunicación", value: "10 - Comunicación" },
    { clave: "11", label: "11 - Desarrollo y extensión del conocimiento", value: "11 - Desarrollo y extensión del conocimiento" }
];

// Datos de ocupaciones específicas (números con decimal)
const OCUPACIONES = {
    "01": [
        { clave: "01.1", label: "01.1 - Agricultura y silvicultura", value: "01.1 - Agricultura y silvicultura" },
        { clave: "01.2", label: "01.2 - Ganadería", value: "01.2 - Ganadería" },
        { clave: "01.3", label: "01.3 - Pesca y acuacultura", value: "01.3 - Pesca y acuacultura" }
    ],
    "02": [
        { clave: "02.1", label: "02.1 - Exploración", value: "02.1 - Exploración" },
        { clave: "02.2", label: "02.2 - Extracción", value: "02.2 - Extracción" },
        { clave: "02.3", label: "02.3 - Refinición y beneficio", value: "02.3 - Refinición y beneficio" },
        { clave: "02.4", label: "02.4 - Provisión de energía", value: "02.4 - Provisión de energía" },
        { clave: "02.5", label: "02.5 - Provisión de agua", value: "02.5 - Provisión de agua" }
    ],
    "03": [
        { clave: "03.1", label: "03.1 - Planeación y dirección de obras", value: "03.1 - Planeación y dirección de obras" },
        { clave: "03.2", label: "03.2 - Edificación y urbanización", value: "03.2 - Edificación y urbanización" },
        { clave: "03.3", label: "03.3 - Acabado", value: "03.3 - Acabado" },
        { clave: "03.4", label: "03.4 - Instalación y mantenimiento", value: "03.4 - Instalación y mantenimiento" }
    ],
    "04": [
        { clave: "04.1", label: "04.1 - Mecánica", value: "04.1 - Mecánica" },
        { clave: "04.2", label: "04.2 - Electricidad", value: "04.2 - Electricidad" },
        { clave: "04.3", label: "04.3 - Electrónica", value: "04.3 - Electrónica" },
        { clave: "04.4", label: "04.4 - Informática", value: "04.4 - Informática" },
        { clave: "04.5", label: "04.5 - Telecomunicaciones", value: "04.5 - Telecomunicaciones" },
        { clave: "04.6", label: "04.6 - Procesos industriales", value: "04.6 - Procesos industriales" }
    ],
    "05": [
        { clave: "05.1", label: "05.1 - Procesamiento y fabricación", value: "05.1 - Procesamiento y fabricación" },
        { clave: "05.2", label: "05.2 - Minerales no metálicos", value: "05.2 - Minerales no metálicos" },
        { clave: "05.3", label: "05.3 - Metales", value: "05.3 - Metales" },
        { clave: "05.4", label: "05.4 - Alimentos y bebidas", value: "05.4 - Alimentos y bebidas" },
        { clave: "05.5", label: "05.5 - Textiles y prendas de vestir", value: "05.5 - Textiles y prendas de vestir" },
        { clave: "05.6", label: "05.6 - Materia orgánica", value: "05.6 - Materia orgánica" },
        { clave: "05.7", label: "05.7 - Productos químicos", value: "05.7 - Productos químicos" },
        { clave: "05.8", label: "05.8 - Productos metálicos y de hule y plástico", value: "05.8 - Productos metálicos y de hule y plástico" },
        { clave: "05.9", label: "05.9 - Productos eléctricos y electrónicos", value: "05.9 - Productos eléctricos y electrónicos" },
        { clave: "05.10", label: "05.10 - Productos impresos", value: "05.10 - Productos impresos" }
    ],
    "06": [
        { clave: "06.1", label: "06.1 - Ferroviario", value: "06.1 - Ferroviario" },
        { clave: "06.2", label: "06.2 - Autotransporte", value: "06.2 - Autotransporte" },
        { clave: "06.3", label: "06.3 - Aéreo", value: "06.3 - Aéreo" },
        { clave: "06.4", label: "06.4 - Marítimo y fluvial", value: "06.4 - Marítimo y fluvial" },
        { clave: "06.5", label: "06.5 - Servicios de apoyo", value: "06.5 - Servicios de apoyo" }
    ],
    "07": [
        { clave: "07.1", label: "07.1 - Comercio", value: "07.1 - Comercio" },
        { clave: "07.2", label: "07.2 - Alimentación y hospedaje", value: "07.2 - Alimentación y hospedaje" },
        { clave: "07.3", label: "07.3 - Turismo", value: "07.3 - Turismo" },
        { clave: "07.4", label: "07.4 - Deporte y esparcimiento", value: "07.4 - Deporte y esparcimiento" },
        { clave: "07.5", label: "07.5 - Servicios personales", value: "07.5 - Servicios personales" },
        { clave: "07.6", label: "07.6 - Reparación de artículos de uso doméstico y personal", value: "07.6 - Reparación de artículos de uso doméstico y personal" },
        { clave: "07.7", label: "07.7 - Limpieza", value: "07.7 - Limpieza" },
        { clave: "07.8", label: "07.8 - Servicio postal y mensajería", value: "07.8 - Servicio postal y mensajería" }
    ],
    "08": [
        { clave: "08.1", label: "08.1 - Bolsa, banca y seguros", value: "08.1 - Bolsa, banca y seguros" },
        { clave: "08.2", label: "08.2 - Administración", value: "08.2 - Administración" },
        { clave: "08.3", label: "08.3 - Servicios legales", value: "08.3 - Servicios legales" }
    ],
    "09": [
        { clave: "09.1", label: "09.1 - Servicios médicos", value: "09.1 - Servicios médicos" },
        { clave: "09.2", label: "09.2 - Inspección sanitaria y del medio ambiente", value: "09.2 - Inspección sanitaria y del medio ambiente" },
        { clave: "09.3", label: "09.3 - Seguridad social", value: "09.3 - Seguridad social" },
        { clave: "09.4", label: "09.4 - Protección de bienes y/o personas", value: "09.4 - Protección de bienes y/o personas" }
    ],
    "10": [
        { clave: "10.1", label: "10.1 - Publicación", value: "10.1 - Publicación" },
        { clave: "10.2", label: "10.2 - Radio, cine, televisión y teatro", value: "10.2 - Radio, cine, televisión y teatro" },
        { clave: "10.3", label: "10.3 - Interpretación artística", value: "10.3 - Interpretación artística" },
        { clave: "10.4", label: "10.4 - Traducción e interpretación lingüística", value: "10.4 - Traducción e interpretación lingüística" },
        { clave: "10.5", label: "10.5 - Publicidad, propaganda y relaciones públicas", value: "10.5 - Publicidad, propaganda y relaciones públicas" }
    ],
    "11": [
        { clave: "11.1", label: "11.1 - Investigación", value: "11.1 - Investigación" },
        { clave: "11.2", label: "11.2 - Enseñanza", value: "11.2 - Enseñanza" },
        { clave: "11.3", label: "11.3 - Difusión cultural", value: "11.3 - Difusión cultural" }
    ]
};

const ItemCarnet = ({
    indice,
    onClickEliminarCarnet,
    catalogos,
    carnet,
    listTipoCarnet,
    carnets,
    setDatosEvento,
    esEditar,
    onClickEditarCarnet,
    parentIsStudent,
}) => {
    const [datos, setDatos] = useState(carnet)
    const [selectCatalogo, setSelectCatalogo] = useState([])
    const [ocupacionesDisponibles, setOcupacionesDisponibles] = useState([])

    useEffect(() => {
        let isS = true;
        if (isS) {
            // If editing and listPuesto is 'Otro (valor)', pre-fill txtPuestoOtro
            if (carnet.listPuesto && carnet.listPuesto.startsWith('Otro (')) {
                setDatos({
                    ...carnet,
                    txtPuestoOtro: carnet.listPuesto.slice(6, -1)
                });
            } else {
                setDatos(carnet);
            }
        }
        return () => (isS = false);
    }, [carnet]);

    useEffect(() => {
        if (!datos.listTipoHospedaje) {
            return
        }

        let formCarnets = carnets.map((s, i) => tools.getForm(`formCarnet${i + 1}`)).map((v) => v.data)

        console.log(5555, formCarnets)

        let numCarnetInd = formCarnets.filter((v) => v.listTipoHospedaje == '1-0' || v.listTipoHospedaje == '1-1').length
        let numCarnetDoble = formCarnets.filter((v) => v.listTipoHospedaje == '2-0' || v.listTipoHospedaje == '2-1').length

        // setSelectCatalogo(catalogos.catHotel.filter((v) => datos.listTipoHospedaje.split('-')[0] == v.TIPO_HHB))

        setDatosEvento((s) => ({
            ...s,
            numCarnetInd: numCarnetInd,
            numCarnetDoble: numCarnetDoble,
            totalAsistentes: numCarnetInd + (numCarnetDoble * 2)
        }))
    }, [datos.listTipoHospedaje])

    // Efecto para actualizar las ocupaciones disponibles cuando cambia el tipo de ocupación
    useEffect(() => {
        // Si el tipo padre es Asistente - Estudiante y ya existe una ocupación en datos,
        // no sobrescribir con la lógica normal; en edición queremos respetar el valor
        const esStudent = parentIsStudent || (listTipoCarnet && listTipoCarnet.clave === '1-88')

        if (esStudent) {
            // Si ya hay una ocupación específica en datos, asegurarnos de que esté disponible
            if (datos.listOcupacion) {
                // Si el valor ya incluye label (ej. '07.8 - Servicio...') extraer clave
                const m = String(datos.listOcupacion).match(/^(\d+\.\d+)\s*-\s*(.+)$/)
                let clave = datos.listOcupacion
                let label = datos.listOcupacion
                if (m) {
                    clave = m[1]
                    label = `${m[1]} - ${m[2]}`
                }
                // Si existe en el catálogo, úsalo; si no, crear una opción temporal
                const tipoClave = String(clave).split('.')[0]
                if (OCUPACIONES[tipoClave] && OCUPACIONES[tipoClave].some(o => o.clave === clave)) {
                    setOcupacionesDisponibles(OCUPACIONES[tipoClave])
                } else {
                    setOcupacionesDisponibles([{ clave: clave, label: label, value: label }])
                }

                // Asegurarnos de que listTipoOcupacion esté definido si es posible
                setDatos(s => ({ ...s, listTipoOcupacion: s.listTipoOcupacion || tipoClave, listOcupacion: clave }))
                return
            }

            // Si no hay ocupación en datos, dejar la lista vacía y no forzar EST aquí
            setOcupacionesDisponibles([])
            return
        }

        // Comportamiento regular cuando no es estudiante
        if (datos.listTipoOcupacion) {
            setOcupacionesDisponibles(OCUPACIONES[datos.listTipoOcupacion] || []);
        } else {
            setOcupacionesDisponibles([]);
        }
        // Limpiar la ocupación específica si se cambia el tipo
        if (datos.listOcupacion && datos.listTipoOcupacion) {
            const tipoDeOcupacion = datos.listOcupacion.split('.')[0];
            if (tipoDeOcupacion !== datos.listTipoOcupacion) {
                setDatos(s => ({ ...s, listOcupacion: '' }));
            }
        }
    }, [datos.listTipoOcupacion, parentIsStudent])

    // Si el tipo de carnet padre es Asistente - Estudiante y no hay ocupación específica en datos,
    // forzar ocupación Estudiante. Si ya hay una ocupación (p. ej. llegada desde backend), respetarla.
    useEffect(() => {
        const esStudent = parentIsStudent || (listTipoCarnet && listTipoCarnet.clave === '1-88')
        if (!esStudent) return

        // Si ya hay una ocupación definida (probablemente parseada por el padre), respetarla
        if (datos.listOcupacion && String(datos.listOcupacion).trim() !== '') {
            return
        }

        // Forzar EST cuando no hay ocupación
        const tipoClave = 'EST'
        const ocupacionClave = 'EST'
        const estudianteTipo = { clave: tipoClave, label: `Estudiante`, value: `Estudiante` }
        setOcupacionesDisponibles([estudianteTipo])
        setDatos(s => {
            if (s.listTipoOcupacion === tipoClave && s.listOcupacion === ocupacionClave) return s
            return { ...s, listTipoOcupacion: tipoClave, listOcupacion: ocupacionClave }
        })
    }, [listTipoCarnet, parentIsStudent])

    return <form className="col-md-12" id={`formCarnet${indice + 1}`} key={`formCarnet${indice + 1}`} data-id={esEditar?datos.id:''}>
        <div className="row">
            <div className="col-12 m-0 p-0">
                <div className="card">
                    <div className="carnet-body">
                        <div
                            className="d-flex flex-wrap mt-4"
                            style={{ justifyContent: "space-between" }}
                        >
                            <h5>Acceso {indice + 1}</h5>
                            {!esEditar && (
                                <button type="button" className="btn btn-danger mb-4 pl-3 pr-3 pb-0 pt-0"
                                    onClick={() => onClickEliminarCarnet(indice, carnet)}
                                >
                                    <i className="fa fa-times" aria-hidden="true"></i>
                                </button>
                            )}
                        </div>
                        {/* {listTipoCarnet.clave == 1?
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label
                                        style={{ fontWeight: 600 }}
                                        htmlFor="pcorreo"
                                    >
                                        Tipo de carnet<span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        className="form-control form-control-md border border-dark"
                                        // tipoValue={1}
                                        data-label="Hospedaje"
                                        placeholder="Seleccionar hospedaje"
                                        id={`listTipoHospedaje${indice + 1}`}
                                        name="listTipoHospedaje"
                                        datos={catalogos.catTipoHospedaje}
                                        value={datos.listTipoHospedaje ? datos.listTipoHospedaje : ''}
                                        onChange={({ item }) => {
                                            setDatos((s) => ({ ...s, listTipoHospedaje: item.clave }))
                                        }}
                                    />
                                    <span className={`text-danger txtVaciosItem${indice + 1} listTipoHospedaje${indice + 1}`} style={{ display: 'none' }}>Falta seleccionar Tipo de hospedaje</span>
                                </div>
                            </div>
                             {datos.listTipoHospedaje == '1-1' || datos.listTipoHospedaje == '2-1' ?
                            <Fragment>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label
                                            style={{ fontWeight: 600 }}
                                            htmlFor="pcorreo"
                                        >
                                            Selecciona un hotel<span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            className="form-control form-control-md border border-dark"
                                            // tipoValue={1}
                                            data-label="Hotel"
                                            placeholder="Seleccionar hotel"
                                            id={`listHotel${indice + 1}`}
                                            name="listHotel"
                                            datos={selectCatalogo}
                                            value={datos.listHotel ? datos.listHotel : ''}
                                            onChange={({ item }) => {
                                                setDatos((s) => ({ ...s, listHotel: item.clave }))
                                            }}
                                        />
                                        <span className={`text-danger txtVaciosItem${indice + 1} listHotel${indice + 1}`} style={{ display: 'none' }}>Falta seleccionar Hotel</span>
                                    </div> 
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label
                                            style={{ fontWeight: 600 }}
                                            htmlFor="pnombre"
                                        >
                                            Camas<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            className="form-control border border-dark"
                                            type="number"
                                            id={`txtCamas${indice + 1}`}
                                            name="txtCamas"
                                            placeholder="Camas"
                                            defaultValue={2}
                                            value={datos.txtCamas}
                                            onChange={(e) => {
                                                e.persist()
                                                setDatos((s) => ({ ...s, txtCamas: e.target.value }))
                                            }}
                                        />
                                        <span className={`text-danger txtVaciosItem${indice + 1} txtCamas${indice + 1}`} style={{ display: 'none' }}>Falta completar (Camas)</span>
                                    </div>
                                </div>
                            </Fragment>
                            : ''} 
                        </div>
                        :''} */}
                        <div className="row">
                            {/* <div className="col-12 mt-4 mb-2">
                                <h5>Asistente 1</h5>
                            </div> */}
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label
                                        style={{ fontWeight: 600 }}
                                        htmlFor="pnombre"
                                    >
                                        Nombre(s)<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className="form-control border border-dark"
                                        type="text"
                                        id={`txtNombre${indice + 1}`}
                                        name="txtNombre"
                                        placeholder="Nombre(s)"
                                        value={datos.txtNombre ? datos.txtNombre : ''}
                                        onInput={(e) => {tools.limitChar(e, 3, 80)}}
                                        onChange={(e) => {
                                            e.persist()
                                            setDatos((s) => ({ ...s, txtNombre: e.target.value }))
                                        }}
                                    />
                                    <span className={`text-danger txtVaciosItem${indice + 1} txtNombre${indice + 1}`} style={{ display: 'none' }}>Falta completar (Nombre(s))</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label
                                        style={{ fontWeight: 600 }}
                                        htmlFor="papellidos"
                                    >
                                        Apellidos<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className="form-control border border-dark"
                                        id={`txtApellidos${indice + 1}`}
                                        name="txtApellidos"
                                        type="text"
                                        placeholder="Apellidos"
                                        value={datos.txtApellidos ? datos.txtApellidos : ''}
                                        onInput={(e) => {tools.limitChar(e, 3, 80)}}
                                        onChange={(e) => {
                                            e.persist()
                                            setDatos((s) => ({ ...s, txtApellidos: e.target.value }))
                                        }}
                                    />
                                    <span className={`text-danger txtVaciosItem${indice + 1} txtApellidos${indice + 1}`} style={{ display: 'none' }}>Falta completar Apellidos</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label
                                        style={{ fontWeight: 600 }}
                                        htmlFor="pcorreo"
                                    >
                                        Correo Electrónico
                                    </label>
                                    <input
                                        className="form-control border border-dark"
                                        id={`txtCorreo${indice + 1}`}
                                        name="txtCorreo"
                                        type="text"
                                        // onBlur={onClickBuscarCorreo}
                                        placeholder="Correo Electrónico"
                                        value={datos.txtCorreo ? datos.txtCorreo : ''}
                                        onInput={(e) => {tools.limitChar(e, 2, 80)}}
                                        onChange={(e) => {
                                            e.persist()
                                            setDatos((s) => ({ ...s, txtCorreo: e.target.value }))
                                        }}
                                    />
                                    <span className={`text-danger txtVaciosItem${indice + 1} txtCorreo${indice + 1}`} style={{ display: 'none' }}>Falta completar Correo Electrónico</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label
                                        style={{ fontWeight: 600 }}
                                        htmlFor="pcorreo"
                                    >
                                        Género
                                    </label>
                                    <Select
                                        className="form-control form-control-md border border-dark"
                                        // tipoValue={1}
                                        data-label="Género"
                                        placeholder="Seleccionar Género"
                                        id={`listGenero${indice + 1}`}
                                        name="listGenero"
                                        datos={catalogos.catGenero}
                                        value={datos.listGenero ? datos.listGenero : ''}
                                        onChange={({ item }) => {
                                            setDatos((s) => ({ ...s, listGenero: item.clave }))
                                        }}
                                    />
                                    <span className={`text-danger txtVaciosItem${indice + 1} listGenero${indice + 1}`} style={{ display: 'none' }}>Falta completar Género</span>
                                </div>
                            </div>

                            {/* CURP y RFC: ocultar si el padre es estudiante (parentIsStudent) */}
                            {!(parentIsStudent || (listTipoCarnet && listTipoCarnet.clave === '1-88')) ? (
                                <>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor={`txtCurp${indice + 1}`}
                                            >
                                                CURP
                                            </label>
                                            <input
                                                className="form-control border border-dark"
                                                type="text"
                                                id={`txtCurp${indice + 1}`}
                                                name="txtCurp"
                                                placeholder="CURP"
                                                maxLength={18}
                                                value={datos.txtCurp || ''}
                                                onChange={(e) => {
                                                    const value = e.target.value.toUpperCase().slice(0, 18);
                                                    setDatos((s) => ({ ...s, txtCurp: value }));
                                                }}
                                            />
                                            <span className={`text-danger txtVaciosItem${indice + 1} txtCurp${indice + 1}`} style={{ display: 'none' }}>Falta completar CURP</span>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor={`txtRfc${indice + 1}`}
                                            >
                                                RFC
                                            </label>
                                            <input
                                                className="form-control border border-dark"
                                                type="text"
                                                id={`txtRfc${indice + 1}`}
                                                name="txtRfc"
                                                placeholder="RFC"
                                                maxLength={13}
                                                value={datos.txtRfc || ''}
                                                onChange={(e) => {
                                                    const value = e.target.value.toUpperCase().slice(0, 13);
                                                    setDatos((s) => ({ ...s, txtRfc: value }));
                                                }}
                                            />
                                            <span className={`text-danger txtVaciosItem${indice + 1} txtRfc${indice + 1}`} style={{ display: 'none' }}>Falta completar RFC</span>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                // Si es estudiante, insertar inputs ocultos para que getForm recoja los valores
                                <>
                                    <input type="hidden" id={`txtCurp${indice + 1}`} name="txtCurp" value={datos.txtCurp || ''} />
                                    <input type="hidden" id={`txtRfc${indice + 1}`} name="txtRfc" value={datos.txtRfc || ''} />
                                </>
                            )}

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label
                                        style={{ fontWeight: 600 }}
                                        htmlFor="pwhatsapp"
                                    >
                                        Whatsapp
                                    </label>
                                    <br></br>
                                    <PhoneInput
                                        id={`txtWhatsapp1${indice + 1}`}
                                        name="txtWhatsapp1"
                                        className={'form-control border border-dark'}
                                        value={datos?.txtWhatsapp  || ''}
                                        label='Whatsapp'
                                        onChange={(datos) => {
                                            setDatos((s) => ({
                                                ...s,
                                                data: {
                                                    ...s.data,
                                                    txtWhatsapp: datos.number,
                                                    txtWhatsappCodPais: datos.code,
                                                    txtWhatsappISO: datos.iso,
                                                }
                                            }));
                                        }}
                                    />
                                    <input id={`txtWhatsapp${indice + 1}`} name="txtWhatsapp" value={datos?.data?.txtWhatsapp  || ''}  hidden/>

                                    <input id={`txtWhatsappCodPais${indice + 1}`} name="txtWhatsappCodPais" value={datos?.data?.txtWhatsappCodPais  || ''}  hidden/>

                                    <input id={`txtWhatsappISO${indice + 1}`} name="txtWhatsappISO" value={datos?.data?.txtWhatsappISO || ''}  hidden/>

                                    <span className={`text-danger txtVaciosItem${indice + 1} txtWhatsapp${indice + 1}`} style={{ display: 'none' }}>Falta completar (Whatsapp)</span>
                                </div>
                            </div>
                            {/* <div className="col-md-6">
                                <div className="form-group">
                                    <label
                                        style={{ fontWeight: 600 }}
                                        htmlFor="pcorreo"
                                    >
                                        Whatsapp
                                    </label>
                                    <div className="input-group mb-2">
                                        <div className="input-group-prepend border">
                                            <div className="input-group-text"><i className="fa fa-whatsapp" aria-hidden="true"></i></div>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control border border-dark"
                                            id={`txtWhatsapp${indice + 1}`}
                                            name="txtWhatsapp"
                                            placeholder="Whatsapp"
                                            value={datos.txtWhatsapp ? datos.txtWhatsapp : ''}
                                            maxLength={10}
                                            onInput={(e) => {
                                                let value = e.target.value.replace(/\D/g, ''); 
                                                e.target.value = value
                                            }}
                                            onChange={(e) => {
                                                e.persist()
                                                setDatos((s) => ({ ...s, txtWhatsapp: e.target.value }))
                                            }}
                                        />
                                    </div>
                                    <span className={`text-danger txtVaciosItem${indice + 1} txtWhatsapp${indice + 1}`} style={{ display: 'none' }}>Falta completar Whatsapp</span>

                                </div>
                            </div> */}

                            <div className="col-md-6">
                                <div className="form-group">
                                    {!(parentIsStudent || (listTipoCarnet && listTipoCarnet.clave === '1-88')) ? (
                                        <label
                                            style={{ fontWeight: 600 }}
                                            htmlFor={`listTipoOcupacion${indice + 1}`}
                                        >
                                            Tipo de ocupación<span className="text-danger">*</span>
                                        </label>
                                    
                                    ) : ''}
                                    {!(parentIsStudent || (listTipoCarnet && listTipoCarnet.clave === '1-88')) ? (
                                        <Select
                                            className="form-control form-control-md border border-dark"
                                            data-label="Tipo de ocupación"
                                            placeholder="Seleccionar tipo de ocupación"
                                            id={`listTipoOcupacion${indice + 1}`}
                                            name="listTipoOcupacion"
                                            datos={TIPOS_OCUPACION}
                                            value={datos.listTipoOcupacion || ''}
                                            onChange={({ item }) => {
                                                setDatos((s) => ({
                                                    ...s,
                                                    listTipoOcupacion: item.clave,
                                                    listOcupacion: ''
                                                }));
                                            }}
                                        />
                                    ) : (
                                        // Al estar oculto, agregar input hidden para que getForm recoja el valor
                                        <input type="hidden" id={`listTipoOcupacion${indice + 1}`} name="listTipoOcupacion" value={datos.listTipoOcupacion || 'EST'} />
                                    )}
                                    <span className={`text-danger txtVaciosItem${indice + 1} listTipoOcupacion${indice + 1}`} style={{ display: 'none' }}>Falta seleccionar Tipo de ocupación</span>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label
                                        style={{ fontWeight: 600 }}
                                        htmlFor={`listOcupacion${indice + 1}`}
                                    >
                                        Ocupación<span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        className="form-control form-control-md border border-dark"
                                        data-label="Ocupación"
                                        placeholder={datos.listTipoOcupacion ? "Seleccionar ocupación" : "Primero selecciona tipo de ocupación"}
                                        id={`listOcupacion${indice + 1}`}
                                        name="listOcupacion"
                                        datos={ocupacionesDisponibles}
                                        includeDataValue={true}
                                        // Si el padre es estudiante, forzar valor EST para que se vea seleccionado
                                        value={(parentIsStudent || (listTipoCarnet && listTipoCarnet.clave === '1-88')) ? ('EST') : (datos.listOcupacion || '')}
                                        // habilitar si hay ocupaciones o si es estudiante
                                        disabled={!(datos.listTipoOcupacion || (parentIsStudent || (listTipoCarnet && listTipoCarnet.clave === '1-88')))}
                                        onChange={({ item }) => {
                                            setDatos((s) => ({
                                                ...s,
                                                listOcupacion: item.clave
                                            }));
                                        }}
                                    />
                                    <span className={`text-danger txtVaciosItem${indice + 1} listOcupacion${indice + 1}`} style={{ display: 'none' }}>Falta seleccionar Ocupación</span>
                                </div>
                            </div>

                            {/* <div className="col-md-6">
                                <div className="form-group">
                                    <label
                                        style={{ fontWeight: 600 }}
                                        htmlFor="Puesto"
                                    >
                                        Puesto específico<span className="text-danger"></span>
                                    </label>
                                    <Select
                                    className="form-control form-control-md border border-dark"
                                    data-label="Puesto"
                                    placeholder="Seleccionar Puesto"
                                    id={`listPuesto${indice + 1}`}
                                    name="txtPuesto"
                                    datos={[ 
                                        { clave: "Estudiante", label: "Estudiante", value: "Estudiante" },
                                        { clave: "Docente", label: "Docente", value: "Docente" },
                                        { clave: "Profesor / Profesora", label: "Profesor / Profesora", value: "Profesor / Profesora" },
                                        { clave: "Coordinador académico", label: "Coordinador académico", value: "Coordinador académico" },
                                        { clave: "Director / Directora", label: "Director / Directora", value: "Director / Directora" },
                                        { clave: "Subdirector / Subdirectora", label: "Subdirector / Subdirectora", value: "Subdirector / Subdirectora" },
                                        datos.listPuesto && datos.listPuesto.startsWith('Otro (')
                                            ? {
                                                clave: datos.listPuesto,
                                                label: 'Otro', 
                                                value: datos.listPuesto
                                            }
                                            : { clave: "Otro", label: "Otro", value: "Otro" }
                                    ]}
                                    value={datos.listPuesto && datos.listPuesto.startsWith('Otro (') ? datos.listPuesto : (datos.listPuesto || '')}
                                    onChange={({ item }) => {
                                        setDatos((s) => ({
                                            ...s,
                                            listPuesto: item.clave,
                                            txtPuestoOtro: item.clave.startsWith('Otro (') ? item.clave.slice(6, -1) : (item.clave === 'Otro' ? (s.txtPuestoOtro || '') : '')
                                        }));
                                    }}
                                />
                                
                                {(datos.listPuesto === 'Otro' || (datos.listPuesto && datos.listPuesto.startsWith('Otro ('))) && (
                                    <input
                                        className="form-control border border-dark mt-2"
                                        type="text"
                                        id={`txtPuestoOtro${indice + 1}`}
                                        name="txtPuestoOtro"
                                        placeholder="Especifica el puesto"
                                        maxLength={50}
                                        value={datos.txtPuestoOtro || ''}
                                        onChange={(e) => {
                                            let profesion = e.target.value.slice(0, 50).trim();
                                            setDatos((s) => ({
                                                ...s,
                                                txtPuestoOtro: profesion,
                                                listPuesto: profesion ? `Otro (${profesion})` : 'Otro'
                                            }));
                                        }}
                                    />
                                )}
                                    <span className={`text-danger txtVaciosItem${indice + 1} listPuesto${indice + 1}`} style={{ display: 'none' }}>Falta completar Puesto</span>
                                </div>
                            </div> */}
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label
                                        style={{ fontWeight: 600 }}
                                        htmlFor={`txtEmpresa${indice + 1}`}
                                    >
                                        Nombre de la empresa/institución<span className="text-danger"></span>
                                    </label>
                                    <input
                                        className="form-control border border-dark"
                                        type="text"
                                        id={`txtEmpresa${indice + 1}`}
                                        name="txtEmpresa"
                                        placeholder="Nombre de la empresa/institución"
                                        maxLength={250}
                                        value={datos.txtEmpresa || ''}
                                        onChange={(e) => {
                                            const value = e.target.value.slice(0, 250);
                                            setDatos((s) => ({ ...s, txtEmpresa: value }));
                                        }}
                                    />
                                    <span className={`text-danger txtVaciosItem${indice + 1} txtEmpresa${indice + 1}`} style={{ display: 'none' }}>Falta completar Nombre de la empresa/institución</span>
                                </div>
                            </div>
                            

                            {(listTipoCarnet.clave == '3') ?
                                <Fragment>
                                    {/* <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="Puesto"
                                            >
                                                Puesto<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                className="form-control border border-dark"
                                                id={`txtPuesto${indice + 1}`}
                                                name="txtPuesto"
                                                type="text"
                                                placeholder="Puesto"
                                                value={datos.txtPuesto ? datos.txtPuesto : ''}
                                                onChange={(e) => {
                                                    e.persist()
                                                    setDatos((s) => ({ ...s, txtPuesto: e.target.value }))
                                                }}
                                            />
                                            <span className={`text-danger txtVaciosItem${indice + 1} txtPuesto${indice + 1}`} style={{ display: 'none' }}>Falta completar Puesto</span>
                                        </div>
                                    </div> */}
                                    {/* <div className="col-md-6">
                                        <div className="form-group">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input border-dark"
                                                    id={`txtEsAnfitrion${indice + 1}`}
                                                    name="txtEsAnfitrion"
                                                    type="checkbox"
                                                    placeholder="Es Anfitrion"
                                                    checked={datos.txtEsAnfitrion ? true : false}
                                                    // value={datos.txtEsAnfitrion? 1: 0}
                                                    // {...(datos.txtEsAnfitrion? checked: '')}
                                                    onChange={(e) => {
                                                        e.persist()
                                                        setDatos((s) => ({ ...s, txtEsAnfitrion: !s.txtEsAnfitrion }))
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor="flexCheckDefault" style={{ fontWeight: 600 }}>
                                                    Es Anfitrion<span className="text-danger">*</span>
                                                </label>
                                                <span className={`text-danger txtVaciosItem${indice + 1} txtEsAnfitrion${indice + 1}`} style={{ display: 'none' }}>Falta completar Anfitrion</span>
                                            </div>
                                        </div>
                                    </div> */}
                                </Fragment>
                                : ''}
                        </div>
                        {datos.listTipoHospedaje == '2-0' || datos.listTipoHospedaje == '2-1' ?
                            <Fragment>
                                <div className="row">
                                    <div className="col-12 mt-4 mb-2">
                                        <h5>Asistente 2</h5>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="pnombre"
                                            >
                                                Nombre(s)<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                className="form-control border border-dark"
                                                type="text"
                                                id={`txtNombreSeg${indice + 1}`}
                                                name="txtNombreSeg"
                                                placeholder="Nombre(s)"
                                                value={datos.txtNombreSeg ? datos.txtNombreSeg : ''}
                                                onChange={(e) => {
                                                    e.persist()
                                                    setDatos((s) => ({ ...s, txtNombreSeg: e.target.value }))
                                                }}
                                            />
                                            <span className={`text-danger txtVaciosItem${indice + 1} txtNombreSeg${indice + 1}`} style={{ display: 'none' }}>Falta completar (Nombre(s))</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="papellidos"
                                            >
                                                Apellidos<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                className="form-control border border-dark"
                                                id={`txtApellidosSeg${indice + 1}`}
                                                name="txtApellidosSeg"
                                                type="text"
                                                placeholder="Apellidos"
                                                value={datos.txtApellidosSeg ? datos.txtApellidosSeg : ''}
                                                onChange={(e) => {
                                                    e.persist()
                                                    setDatos((s) => ({ ...s, txtApellidosSeg: e.target.value }))
                                                }}
                                            />
                                            <span className={`text-danger txtVaciosItem${indice + 1} txtApellidosSeg${indice + 1}`} style={{ display: 'none' }}>Falta completar Apellidos</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="pcorreo"
                                            >
                                                Correo Electrónico
                                            </label>
                                            <input
                                                className="form-control border border-dark"
                                                id={`txtCorreoSeg${indice + 1}`}
                                                name="txtCorreoSeg"
                                                type="text"
                                                // onBlur={onClickBuscarCorreo}
                                                placeholder="Correo Electrónico"
                                                value={datos.txtCorreoSeg ? datos.txtCorreoSeg : ''}
                                                onChange={(e) => {
                                                    e.persist()
                                                    setDatos((s) => ({ ...s, txtCorreoSeg: e.target.value }))
                                                }}
                                            />
                                            <span className={`text-danger txtVaciosItem${indice + 1} txtCorreoSeg${indice + 1}`} style={{ display: 'none' }}>Falta completar Correo Electrónico</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="pcorreo"
                                            >
                                                Género
                                            </label>
                                            <Select
                                                className="form-control form-control-md border border-dark"
                                                // tipoValue={1}
                                                data-label="Género"
                                                placeholder="Seleccionar Género"
                                                id={`listGeneroSeg${indice + 1}`}
                                                name="listGeneroSeg"
                                                datos={catalogos.catGenero}
                                                value={datos.listGeneroSeg ? datos.listGeneroSeg : ''}
                                                onChange={({ item }) => {
                                                    setDatos((s) => ({ ...s, listGeneroSeg: item.clave }))
                                                }}
                                            />
                                            <span className={`text-danger txtVaciosItem${indice + 1} listGeneroSeg${indice + 1}`} style={{ display: 'none' }}>Falta completar Género</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="pcorreo"
                                            >
                                                Whatsapp
                                            </label>
                                            <div className="input-group mb-2">
                                                <div className="input-group-prepend border">
                                                    <div className="input-group-text"><i className="fa fa-whatsapp" aria-hidden="true"></i></div>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control border border-dark"
                                                    id={`txtWhatsappSeg${indice + 1}`}
                                                    name="txtWhatsappSeg"
                                                    placeholder="Whatsapp"
                                                    value={datos.txtWhatsappSeg ? datos.txtWhatsappSeg : ''}
                                                    onChange={(e) => {
                                                        e.persist()
                                                        setDatos((s) => ({ ...s, txtWhatsappSeg: e.target.value }))
                                                    }}
                                                />
                                            </div>
                                            <span className={`text-danger txtVaciosItem${indice + 1} txtWhatsappSeg${indice + 1}`} style={{ display: 'none' }}>Falta completar Whatsapp</span>
                                        </div>
                                    </div>
                                    {(listTipoCarnet.clave == '3') ?
                                        <Fragment>
                                            {/* <div className="col-md-6">
                                                <div className="form-group">
                                                    <label
                                                        style={{ fontWeight: 600 }}
                                                        htmlFor="Puesto"
                                                    >
                                                        Puesto
                                                    </label>
                                                    <input
                                                        className="form-control border border-dark"
                                                        id={`txtPuestoSeg${indice + 1}`}
                                                        name="txtPuestoSeg"
                                                        type="text"
                                                        placeholder="Puesto"
                                                        value={datos.txtPuestoSeg ? datos.txtPuestoSeg : ''}
                                                        onChange={(e) => {
                                                            e.persist()
                                                            setDatos((s) => ({ ...s, txtPuestoSeg: e.target.value }))
                                                        }}
                                                    />
                                                    <span className={`text-danger txtVaciosItem${indice + 1} txtPuestoSeg${indice + 1}`} style={{ display: 'none' }}>Falta completar Puesto</span>
                                                </div>
                                            </div> */}
                                            {/* <div className="col-md-6">
                                    <div className="form-group">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input border-dark"
                                                id={`txtEsAnfitrion${indice + 1}`} 
                                                name="txtEsAnfitrion"
                                                type="checkbox"
                                                placeholder="Es Anfitrion"
                                                checked={datos.txtEsAnfitrion? true: false}
                                                // value={datos.txtEsAnfitrion? 1: 0}
                                                // {...(datos.txtEsAnfitrion? checked: '')}
                                                onChange={(e) => {
                                                    e.persist()
                                                    setDatos((s) => ({ ...s, txtEsAnfitrion: !s.txtEsAnfitrion }))
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="flexCheckDefault"  style={{ fontWeight: 600 }}>
                                                Es Anfitrion<span className="text-danger">*</span>
                                            </label>
                                            <span className={`text-danger txtVaciosItem${indice + 1} txtEsAnfitrion${indice + 1}`} style={{display: 'none'}}>Falta completar Anfitrion</span>  
                                        </div>
                                    </div>
                                </div> */}
                                        </Fragment>
                                        : ''}
                                </div>
                            </Fragment>
                            : ''}
                        {/* {datos.listTipoHospedaje == '1-1' || datos.listTipoHospedaje == '2-1' ?
                            <Fragment>
                                <div className="row mt-5">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="pnombre"
                                            >
                                                Fecha de entrada<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                className="form-control border border-dark"
                                                type="date"
                                                id={`txtFechaInicio${indice + 1}`}
                                                name="txtFechaInicio"
                                                placeholder="Nombre(s)"
                                                value={datos.txtFechaInicio ? datos.txtFechaInicio : ''}
                                                onChange={(e) => {
                                                    e.persist()
                                                    setDatos((s) => ({ ...s, txtFechaInicio: e.target.value }))
                                                }}
                                            />
                                            <span className={`text-danger txtVaciosItem${indice + 1} txtFechaInicio${indice + 1}`} style={{ display: 'none' }}>Falta completar (Nombre(s))</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label
                                                style={{ fontWeight: 600 }}
                                                htmlFor="pnombre"
                                            >
                                                Fecha de salida<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                className="form-control border border-dark"
                                                type="date"
                                                id={`txtFechaFin${indice + 1}`}
                                                name="txtFechaFin"
                                                placeholder="Nombre(s)"
                                                value={datos.txtFechaFin ? datos.txtFechaFin : ''}
                                                onChange={(e) => {
                                                    e.persist()
                                                    setDatos((s) => ({ ...s, txtFechaFin: e.target.value }))
                                                }}
                                            />
                                            <span className={`text-danger txtVaciosItem${indice + 1} txtFechaFin${indice + 1}`} style={{ display: 'none' }}>Falta completar (Nombre(s))</span>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        : ''} */}
                        <div>
                        {esEditar? 
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <div className="row d-flex justify-content-end">
                                    <div className="col-md-4">
                                        <button type="button" className="btn btn-primary btn-lg btn-block"
                                            onClick={() => onClickEditarCarnet(indice, carnet)}
                                        >Guardar Carnet #{indice + 1}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : ''}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
}

export default ItemCarnet